export var breakpoints = {
    smMax: "max-width: 425px",
    mdMin: "min-width: 426px",
    lgMin: "min-width: 769px"
};
